import React from "react";
import Select from "react-select";
import { ReactSelectTagOption } from "../../components/mother-ticket-tag-select/mother-ticket-tag-select";
import { DwsimProDialogTypes, getDwsimProDialogTypeLabel } from "./dwsim-pro-dialog-type.utilities";

type DwsimProDialogTypeFilterProps = {
    className?: string;
    placeholder: string;
    icon?: string;
    iconColor?: string;
    values?: string[] | number[] | undefined | null;
    onChange?: (values: ReactSelectTagOption[]) => void;
}

const options = DwsimProDialogTypes.map(x => ({ value: +x, label: getDwsimProDialogTypeLabel(x) } as ReactSelectTagOption));

export const DwsimProDialogTypeFilter: React.FC<DwsimProDialogTypeFilterProps> = (props) => {

    const [selectedOptions, setSelectedOptions] = React.useState<ReactSelectTagOption[]>();

    React.useEffect(() => {

        if (props.values === undefined || props.values === null) {
            setSelectedOptions(undefined);
            return;
        }
        //@ts-ignore
        const selectedValues = options.filter(x => props.values?.find(y => +x.value! == +y) !== undefined);
        setSelectedOptions(selectedValues);

    }, [props.values, options]);


    return <div style={{ display: "flex" }}>
        <Select
            styles={{
                container: (provided, props) => { return { ...provided, flex: 1 } },
                control: (provided) => { if (!!props.icon) { return { ...provided, borderBottomLeftRadius: 0, borderTopLeftRadius: 0 } } return provided; }
            }}
            placeholder={props.placeholder}
            className={props.className}
            value={selectedOptions}
            isClearable
            isMulti
            options={options}
            onChange={(data) => {

                props.onChange?.(data as any);
            }}
        />
    </div>
}